<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2023-01-11 17:21:23
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2023-01-11 17:37:08
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\pushManagement\dialogComponent\recordFolder.vue
 * @tips: 病历夹弹窗
-->
<!--  -->
<template>
    <div class=''>
        <el-dialog title="病历夹发送编辑" custom-class="dossier-dialog" v-if="dossier.visible" :visible.sync="dossier.visible"
            width="40%" :before-close="dossierHandleClose">
            <div class="dossier-box">
                <el-form :model="dossier" :rules="dossierRules" ref="dossierRuleForm" label-width="60px"
                    label-suffix=":" class="demo-ruleForm">
                    <el-form-item label="标题" prop="title">
                        <el-input placeholder="最多输入10个字" maxlength="10" size="mini" v-model="dossier.title" clearable>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="正文" prop="content">
                        <el-input type="textarea" size="mini" :rows="3" placeholder="请输入正文" v-model="dossier.content"
                            maxlength="50" show-word-limit clearable>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dossierReset('dossierRuleForm')">重 置</el-button>
                <el-button type="primary" size="mini" @click="patientCasePush('dossierRuleForm')">发 送</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    data() {
        //这⾥存放数据
        return {
            // 病历夹
            dossier: {
                visible: false,
                title: "上传病历", // 标题
                content: "请上传您的病历，让我们更好的为您服务", // 内容
                emitType:'病历夹'
            },
            dossierRules: {
                title: [
                    { required: true, message: "必须输入标题", trigger: "blur" },
                    { min: 1, max: 10, message: "标题最多可输入10个字", trigger: "blur" }
                ],
                content: [{ required: true, message: "必须输入正文", trigger: "blur" }]
            },
        };
    },
    //监听属性类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //⽅法集合
    methods: {
        openDialog() {
            this.dossier.visible = true;
        },
        dossierReset(formName) {
            // this.$refs[formName].resetFields();
            this.dossier.title = "";
            this.dossier.content = "";
        },
        // 发送病历夹
        patientCasePush(formName) {
            this.$refs.dossierRuleForm.validate(async valid => {
                if (valid) {
                    this.$emit('receiveParams', this.dossier)
                    this.dossier.visible = false;
                } else {
                    return false;
                }
            });
        },
        //关闭
        dossierHandleClose() {
            this.dossier.visible = false;
            this.$refs["dossierRuleForm"].resetFields();
        },
    },
    //⽣命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //⽣命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(() => {
            this.$on('openDialog', () => {
                this.openDialog()
            });
        });
    },
    //beforeCreate() {}, //⽣命周期 - 创建之前
    //beforeMount() {}, //⽣命周期 - 挂载之前
    //beforeUpdate() {}, //⽣命周期 - 更新之前
    //updated() {}, //⽣命周期 - 更新之后
    //beforeDestroy() {}, //⽣命周期 - 销毁之前
    //destroyed() {}, //⽣命周期 - 销毁完成
    //activated() {}, //如果页⾯有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
/* @import url(); 引⼊公共css类 */
</style>